import { gql } from '@apollo/client';

export const ADDITIONAL_DATA_QUERY = gql`
  query additionalData($documentId: Int!, $siteId: Int!) {
    additionalData(documentId: $documentId, siteId: $siteId) {
      acquisitionExchangeRateId
      adjustedInternalInterestRate
      clientConversionFactor
      clientFacilityId
      clientFacilityNumber
      clientFacilityRORAC
      clientInvoicingBankId
      creditFinancingLine {
        creditFinancingLineId
        creditFinancingLineNumber
        creditFinancingLineSiteId
      }
      dae
      documentId
      facilityDate
      facilityId
      facilityNumber
      facilitySiteId
      facilityStateName
      hideDAE
      hideIIR
      hideRORAC
      interestReadOnly
      interestTypeId
      interestVariablePercent
      internalInterestRate
      invoicingExchangeRateId
      isFixed
      margin
      offerTypeId
      rorac
      scheduleDueDay
      scheduleTypeId
      siteId
      supplierConversionFactor
      supplierInvoicingBankId
      transactionTypeName
      variableInterestDate
      firstScheduleDate
    }
  }
`;

export const REFERENCE_INTERESTS_QUERY = gql`
  query referenceInterests {
    referenceInterests {
      interestTypeId
      interestTypeName
      isFixed
      currencyCode
    }
  }
`;

export const INVOICING_EXCHANGE_RATES_QUERY = gql`
  query invoicingExchangeRates {
    invoicingExchangeRates {
      invoicingExchangeRateId
      invoicingExchangeRateName
    }
  }
`;

export const ACQUISITION_EXCHANGE_RATE_QUERY = gql`
  query acquisitionExchangeRates {
    acquisitionExchangeRates {
      acquisitionExchangeRateId
      acquisitionExchangeRateName
    }
  }
`;

export const CREDIT_FINANCING_LINE_QUERY = gql`
  query creditFinancingLines {
    creditFinancingLines {
      creditFinancingLineId
      creditFinancingLineNumber
      creditFinancingLineSiteId
    }
  }
`;

export const INVOICING_BANK_QUERY = gql`
  query invoicingBanks {
    invoicingBanks {
      bankId
      bankName
    }
  }
`;

export const SCHEDULE_TYPE_QUERY = gql`
  query scheduleTypes {
    scheduleTypes {
      scheduleTypeId
      scheduleTypeName
    }
  }
`;

export const INTEREST_TYPE_QUERY = gql`
  query interestTypes {
    interestTypes {
      id
      code
      name
    }
  }
`;

export const OFFER_TYPE_QUERY = gql`
  query offerTypes($documentTypeId: Int!) {
    offerTypes(documentTypeId: $documentTypeId) {
      offerTypeId
      offerTypeName
      offerTypeCode
      isSystem
      implicit
    }
  }
`;

export const FINANCIAL_PRODUCT_RULE_OUTPUT_QUERY = gql`
  query financialProductRuleOutputData($documentId: Int!, $siteId: Int!) {
    financialProductRuleOutputData(documentId: $documentId, siteId: $siteId) {
      documentId
      siteId
      advancePercentReadOnly
      scheduleDueDayReadOnly
      managementFeePercentReadOnly
      interestFixedPercentReadOnly
      rezidualAmountReadOnly
      managementFeeReadOnly
      durationReadOnly
      financedPercentReadOnly
      rezidualPercentReadOnly
      interestPercentReadOnly
    }
  }
`;

export const OFFER_HEADER_QUERY = gql`
  query offerHeaders($documentId: Int!, $siteId: Int!) {
    offerHeaders(documentId: $documentId, siteId: $siteId) {
      documentId
      siteId
      offerTypeId
      offerTypeName
      offerNumber
      offerDate
      client {
        clientId
        clientName
        partnerTypeCode
        partnerTypeId
        partnerTypeName
        isPf
        isPj
        isPfa
      }
      stateId
      stateName
      documentTypeId
      financialProductId
      financialProductName
      activeStep
      isActive
      responsibleId
      responsibleName
      sourceDocumentId
      sourceDocumentNumber
      isOfferCopied
      userName
      responsiblePartnerId
      responsiblePartnerName
      dealerId
      dealerName
      userPartnerId
      userPartnerName
      accountManagerId
      accountManager
      sourceTypeId
      sourceTypeName
      channelTypeId
      channelTypeName
      currencyId
      currencyCode
      isReplacementOffer
      offerPriorityName
      offerPriorityId
      folderId
      folderSiteId
      contractTypeId
      contractTypeName
      partnerGroupId
      processing
      clientCardVisibilitiesByRole {
        role
        partnerRoleCode
        cards {
          id
          visible
        }
      }
      hasAnyCompetenceOrder
      hasActiveAsset
    }
  }
`;
